if(window.location.pathname === '/pages/wholesale-signup'){
  setTimeout(() => {
    const elms = document.querySelectorAll("#bss-b2b-registration-form-top, #RegisterForm .field, #bss-b2b-registration-form-render .form-group:not(.formbuilder-checkbox-group, .formbuilder-file, .formbuilder-autocomplete)"); 
    if(elms.length){
      elms.forEach(elm => {
        const label = elm.querySelector("label");
        const input = elm.querySelector("input, select, textarea");
        if(input){
          if(!input.placeholder || input.placeholder == ''){
            input.placeholder = label.textContent;
          }
          input.after(label);
        }
      })
    }
    
  }, 300)
}